import React from 'react';
import Edit from 'containers/rest/Edit';
import moment from 'moment';
import Form from '../components/Form';

const CentresEdit = (props) => {
  const formatOnSubmit = ({ dateApplied, ...data }) => ({
    ...data,
    dateApplied: dateApplied
      ? moment(dateApplied).format('DD-MM-YYYY')
      : dateApplied,
  });

  return (
    <Edit
      {...props}
      resource="centres"
      isClearCurrent={false}
      defaultOptions={{ isRequestApi: false, isTrimStr: true }}
      formatOnSubmit={formatOnSubmit}
    >
      <Form />
    </Edit>
  );
};

export default CentresEdit;
